module.exports = __webpack_public_path__ + "img/app.00768001.jpg";